<template>
    <div class="lms__superadmin_workspaces_edit_footer">
        <component-title :size="'medium'">Help contacts</component-title>
        <form-email
            :label="'Helpdesk email address'"
            :name="'lms-superadmin-workspaces-edit-footer-email-address'"
            :data-vv-as="'email address'"
            :v-validate="{ required: true }"
            v-model="workspaceFooterHelpdeskEmail"
        >e.g. joe.smith@domain.co.uk</form-email>
        <form-text
            :label="'Helpdesk phone number'"
            :name="'lms-superadmin-workspaces-edit-footer-phone-number'"
            :data-vv-as="'phone number'"
            :v-validate="{ regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/ }"
            v-model="workspaceFooterHelpdeskPhone"
        >e.g. +44 1234 567890</form-text>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import { performReset, performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'
import FormText from '@/components/default/forms/FormText'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import FormEmail from '@/components/default/forms/FormEmail'

export default {
  name: 'lms-superadmin-workspace-edit-footer',
  components: { FormEmail, ComponentTitle, FormText, PopNotify },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    workspaceFooterHelpdeskEmail: {
      get () {
        return this.$store.getters.getLmsSuperadminWorkspaceCustomisationHelpdeskEmail
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminWorkspaceSetCustomisationHelpdeskEmail', value)
      }
    },
    workspaceFooterHelpdeskPhone: {
      get () {
        return this.$store.getters.getLmsSuperadminWorkspaceCustomisationHelpdeskPhone
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminWorkspaceSetCustomisationHelpdeskPhone', value)
      }
    }
  },
  inject: ['$validator']
}
</script>
